import { Elements } from '@stripe/react-stripe-js';
import { loadStripe } from '@stripe/stripe-js';
import { useContext } from 'react';

import { BrandContext, HOME_CHEF } from 'context/BrandContext';
import { getEnvConstants } from 'helpers/envConstants';
import Karla from 'Karla.ttf';

const { STRIPE_PUBLIC_KEY } = getEnvConstants();
const stripePromise = loadStripe(STRIPE_PUBLIC_KEY);

const KARLA_URL = 'https://asset.homechef.com/fonts/Karla.ttf';

/**
 *
 * Provides access to Stripe element components and the Stripe object to any
 * child component.
 * Read more: https://stripe.com/docs/stripe-js/react#elements-provider
 *
 */

const StripeElements = ({ children, options = {} }) => {
  const { brand } = useContext(BrandContext);

  const defaultOptions = {
    appearance: {
      rules: {
        '.Label': {
          fontSize: '17px',
        },
        '.Input': {
          borderColor: '#8c9196',
        },
      },
      variables: {
        fontFamily: brand === HOME_CHEF ? 'Karla, Helvetica Neue' : 'aktiv-grotesk, Helvetica Neue',
        gridRowSpacing: '24px',
      },
    },
    paymentMethodCreation: 'manual',
    mode: 'setup',
    currency: 'usd',
    fonts: [
      {
        src: `url(${process.env.NODE_ENV === 'development' ? KARLA_URL : Karla})`,
        family: 'Karla',
        weight: '400',
      },
    ],
  };

  const mergedOptions = { ...defaultOptions, ...options };

  return (
    <Elements stripe={stripePromise} options={mergedOptions}>
      {children}
    </Elements>
  );
};

StripeElements.propTypes = {
  children: PropTypes.node.isRequired,
  options: PropTypes.object,
};

export default StripeElements;
